import { render, staticRenderFns } from "./TheBottomPanel.vue?vue&type=template&id=3a7a85c5&scoped=true&"
import script from "./TheBottomPanel.vue?vue&type=script&lang=ts&"
export * from "./TheBottomPanel.vue?vue&type=script&lang=ts&"
import style0 from "./TheBottomPanel.vue?vue&type=style&index=0&id=3a7a85c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7a85c5",
  null
  
)

export default component.exports